var map = {
	"./data_boms6.0.js": 139,
	"./data_ocrm.js": 140
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;


//////////////////
// WEBPACK FOOTER
// ./core-build-local/lib/testData ^\.\/data_.*\.js$
// module id = 106
// module chunks = 96 97 98 99